const join = require('url-join');

// This function generates all the resource URLs from the base server URL
export default function generateURLs(servletUrl, fastServerUrl) {
  return {
    ASSIGN_FOLLOWED_TEAMS_URL: join(servletUrl, 'assign-followed-teams'),
    AUTOFILL_GRID_URL: join(servletUrl, 'selectedgames', 'autofill'),
    ATTENDED_GAMES_URL: join(servletUrl, 'attendedgames'),

    BASE_TOKEN_URL: join(servletUrl, 'authentication'),

    COURTS_URL: join(servletUrl, 'courts'),
    CONTACT_US_URL: join(servletUrl, 'contactus'),

    DIVISIONS_URL: join(servletUrl, 'divisions'),

    EVENTS_URL: join(servletUrl, 'events'),
    EVENT_DATA_UPDATE_URL: join(servletUrl, 'eventdata', 'update'),
    EVENTS_ICS_URL: join(servletUrl, 'events-ics'),

    FOLLOWED_TEAMS_URL: join(servletUrl, 'followedteams'),

    FIELDS_URL: join(servletUrl, 'fields'),
    FIELD_VALUES_URL: join(servletUrl, 'field-values'),

    GAMES_URL: join(servletUrl, 'games'),

    GAME_GROUPS_URL: join(servletUrl, 'gamegroups'),
    ACCOUNT_INFO_URL: join(servletUrl, 'account'),

    GOOGLE_LOCATIONS_API: join(servletUrl, 'google', 'locations'),
    GOOGLE_PLACES_API: join(servletUrl, 'google', 'places'),

    LOCATION_ALIASES_URL: join(servletUrl, 'locationaliases'),
    ACCOUNT_INFO_URL: join(servletUrl, 'account'),

    LISTS_URL: join(servletUrl, 'recruit-lists'),
    LEAGUES_URL: join(servletUrl, 'leagues'),
    LOGIN_URL: join(servletUrl, 'authentication'),

    MISSING_SCHOOL_INFO_URL: join(servletUrl, 'missingschoolinfo'),
    MEDIA_ATTACHMENTS_UPLOAD: join(servletUrl, 'mediaattachments', 'upload'),
    MAKE_ICS_TOKEN_LINK_URL: join(servletUrl, 'events-ics', 'token'),

    NOTES_URL: join(servletUrl, 'notes'),
    NOTIFICATIONS_URL: join(servletUrl, 'notifications'),
    NOTIFICATION_RECIPIENTS_URL: join(servletUrl, 'notificationrecipients'),

    CALCULATE_POOL_STANDINGS_URL: join(servletUrl, 'calculate-pool-standings'),
    POOL_STANDINGS_URL: join(servletUrl, 'pool-standings'),
    PROFILES_URL: join(servletUrl, 'importprofiles'),
    PROCESSED_GAME_DATA: join(servletUrl, 'processedgamedata'),

    RECRUIT_APPOINTMENTS_URL: join(servletUrl, 'recruitappointments'),
    RECRUITS_COLUMNS_URL: join(servletUrl, 'recruits', 'import', 'columns'),
    RECRUITS_IMPORT_URL: join(servletUrl, 'recruits', 'import'),
    RECRUITS_MERGE_URL: join(servletUrl, 'recruits', 'merge'),
    RECRUITS_PROFILES_URL: join(servletUrl, 'importprofiles'),
    RECRUITS_URL: join(servletUrl, 'recruits'),
    RECRUITS_YEARS_URL: join(servletUrl, 'recruits', 'years'),
    REPORT_MISSING_SCHOOL_URL: join(servletUrl, 'reportmissingschool'),
    ACCOUNT_USERS_URL: join(fastServerUrl, 'accountusers'),

    SCHEDULE_VALIDATIONS: join(servletUrl, 'schedule-validations'),
    SCHEDULE_IMPORT_URL: join(servletUrl, 'schedule-import'),
    CLIENT_SCHEDULE_IMPORT_URL: join(servletUrl, 'schedule-import', 'custom'),
    SCHOOL_GAMES_URL: join(servletUrl, 'schoolgames'),
    SCHOOL_COUNTS_URL: join(servletUrl, 'schoolleaguecounts'),
    SEED_BRACKETS_URL: join(servletUrl, 'seed-brackets'),
    SEND_ICS_LINK_URL: join(servletUrl, 'events-ics', 'email'),
    SELECTED_GAMES_URL: join(servletUrl, 'selectedgames'),
    SESSIONS_URL: join(servletUrl, 'sessions'),

    SOURCE_SUPPRESSIONS_URL: join(servletUrl, 'source-suppressions'),

    SCRAPE_JOBS_URL: join(servletUrl, 'scrapejobs'),
    SCHEDULE_INFO_URL: join(servletUrl, 'schedule-info'),
    SCHOOLS_URL: join(servletUrl, 'schools'),
    SCHOOL_ALIASES_URL: join(servletUrl, 'schoolaliases'),
    SCHOOL_BRACKETS_URL: join(servletUrl, 'school-brackets'),
    SCHOOL_SOURCES_URL: join(servletUrl, 'schoolsources'),
    SCHOOL_SOURCES_IMPORT_URL: join(servletUrl, 'schoolsources', 'import'),
    SCHEDULE_TOKENS_URL: join(servletUrl, 'schedule-tokens'),
    STAFF_URL: join(servletUrl, 'staff'),

    SOCIAL_FEED_URL: join(servletUrl, 'social-feed'),

    TOURNEY_APPOINTMENTS_URL: join(servletUrl, 'tourneyappointments'),
    TOURNEYS_BULK_UPDATE_URL: join(servletUrl, 'tourneys', 'bulkupdate'),
    TOURNEY_TEAMS_SWAP_URL: join(servletUrl, 'tourneyteams', 'swap'),
    TOURNEY_TEAMS_URL: join(servletUrl, 'tourneyteams'),
    TOURNEYS_URL: join(servletUrl, 'tourneys'),
    TASKS_URL: join(servletUrl, 'task-requests'),

    UPDATE_SCORE_URL: join(servletUrl, 'update-game-score'),

    USER_TOURNEYS_URL: join(servletUrl, 'usertourneys'),

    VENUES_URL: join(servletUrl, 'venues')
  };
}



// WEBPACK FOOTER //
// ./src/js/util/urls.js